package com.eladfinish.bible.contest.di

import com.eladfinish.bible.contest.features.copyOptions.CopyOptionsStore
import com.eladfinish.bible.contest.screens.americanQuestions.AmericanQuestionsStore
import com.eladfinish.bible.contest.screens.browse.contentOfChapter.BrowseChaptersStore
import com.eladfinish.bible.contest.screens.browse.tableOfContents.BrowseColumnsStore
import com.eladfinish.bible.contest.screens.browse.tableOfContents.BrowseTabsStore
import com.eladfinish.bible.contest.screens.completeVerse.CompleteVerseStore
import com.eladfinish.bible.contest.screens.main.MainScreenStore
import com.eladfinish.bible.contest.screens.mikud.MikudStore
import com.eladfinish.bible.contest.screens.misc.MiscStore
import com.eladfinish.bible.contest.screens.monopoly.MonopolyStore
import com.eladfinish.bible.contest.screens.names.NamesStore
import com.eladfinish.bible.contest.screens.openQuestions.OpenQuestionsStore
import com.eladfinish.bible.contest.screens.pairMatching.PairMatchingStore
import com.eladfinish.bible.contest.screens.pyramidCrossword.PyramidCrosswordStore
import com.eladfinish.bible.contest.screens.randomVerse.RandomVerseStore
import com.eladfinish.bible.contest.screens.search.SearchStore
import com.eladfinish.bible.contest.screens.settings.SettingsStore
import com.eladfinish.bible.contest.screens.verseWidget.VerseWidgetStore
import org.koin.core.module.Module
import org.koin.core.module.dsl.factoryOf
import org.koin.dsl.module

actual val presentationModulePlatform: Module = module {

    factoryOf(::MainScreenStore)
    factoryOf(::MikudStore)
    factoryOf(::AmericanQuestionsStore)
    factoryOf(::BrowseTabsStore)
    factoryOf(::BrowseChaptersStore)
    factoryOf(::BrowseColumnsStore)
    factoryOf(::MonopolyStore)
    factoryOf(::OpenQuestionsStore)
    factoryOf(::PyramidCrosswordStore)
    factoryOf(::PairMatchingStore)
    factoryOf(::MiscStore)
    factoryOf(::VerseWidgetStore)
    factoryOf(::NamesStore)
    factoryOf(::SearchStore)
    factoryOf(::CompleteVerseStore)
    factoryOf(::SettingsStore)
    factoryOf(::RandomVerseStore)
    factoryOf(::CopyOptionsStore)
}
